import { toast } from "sonner";
import api from "@/lib/api";

// "Moved to Trash" toast with an Undo button that restores the recipes straight away.
export function toastTrashed(ids, { message, onUndone } = {}) {
  const n = ids.length;
  toast.success(message || `${n} recipe${n === 1 ? "" : "s"} moved to Trash`, {
    description: "Restore from Trash within 30 days.",
    duration: 8000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.post("/me/recipe-trash/restore", { recipe_ids: ids });
          toast.success(n === 1 ? "Recipe restored" : `${n} recipes restored`);
          (onUndone || (() => window.location.reload()))();
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Couldn't undo. You can still restore from Trash.");
        }
      },
    },
  });
}
